// src/app/routes.tsx
import AboutUs from "../pages/home/AboutUs";
import Donate from "../pages/home/Donate";
import LoginPage from "../pages/auth/Login";
import RegisterPage from "../pages/auth/Register";
import VerifyCode from "../pages/auth/VerifyCode";
import ForgotPasswordPage from "../pages/auth/ForgotPassword";
import ResetPasswordPage from "../pages/auth/ResetPassword";
import AuthenticationPendingPage from "../pages/auth/AuthenticationPending";
import HymnPage from "../pages/home/Hymn";
import ZoomPage from "../pages/home/Zoom";
import ContactPage from "../pages/home/Contact";
import GalleryPage from "../pages/home/Gallery";
import PrayerVigilPage from "../pages/home/PrayerVigil";
import { Navigate } from "react-router-dom";
import NotFoundPage from "../pages/home/NotFoundPage";
import TeachingPage from "../pages/home/Teaching";
import FavoritePage from "../pages/home/Favorite";
import EditProfilePage from "../pages/home/EditProfilePage";
import ChangePasswordPage from "../pages/auth/ChangePassword";
import ExhortationPage from "../pages/home/Exhortation";
import ArchivePage from "../pages/home/Archive";
import SearchPage from "../pages/home/Search";

export const routes = [
  { path: "/", element: <Navigate to="/teachings" replace /> },
  { path: "/login", element: <LoginPage />, isPublic: true },
  { path: "/register", element: <RegisterPage />, isPublic: true },
  { path: "/verify-code", element: <VerifyCode />, isPublic: true },
  { path: "/forgot-password", element: <ForgotPasswordPage />, isPublic: true },
  { path: "/reset-password", element: <ResetPasswordPage />, isPublic: true },
  {
    path: "/authentication-pending",
    element: <AuthenticationPendingPage />,
    isPublic: true,
  },

  { path: "/favorites", element: <FavoritePage /> },
  { path: "/gallery", element: <GalleryPage /> },
  { path: "/archives", element: <ArchivePage /> },
  { path: "/hymns", element: <HymnPage /> },
  { path: "/exhortations", element: <ExhortationPage /> },
  { path: "/night-vigils", element: <PrayerVigilPage /> },
  { path: "/prayer-vigils", element: <Navigate to="/night-vigils" replace /> },
  { path: "/teachings", element: <TeachingPage /> },
  { path: "/search", element: <SearchPage /> },
  { path: "/edit-profile", element: <EditProfilePage /> },
  { path: "/change-password", element: <ChangePasswordPage /> },

  { path: "/zoom-prayers", element: <ZoomPage /> },
  { path: "/donate", element: <Donate /> },
  { path: "/about-us", element: <AboutUs /> },
  { path: "/contact", element: <ContactPage /> },
  { path: "*", element: <NotFoundPage /> },
];
